import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal'
import VersionModal from '../Components/VersionHistoryModal'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    
    return [day, month, year].join('-');
  }
  
  
  export default  class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state={
         
        supplierName: "ABC Tech Inc.",
        select: true,
        open: false,
        RetentionPaymentModal: false,
        RetentionDocumentsModal:false,
        UploadSuccessModal:false,
        OpenVersionModal:false,
        selectAll: false,
        checked: [],
        opacity:"",
        multiCollapseIndex:"",
        array:[
          {   value: 1, label: "element1"   },
          {   value: 2, label: "element2"    },
          {   value: 3, label: "element3"    },
          {   value: 4, label: "element4"    }],
          versiondata:[
            {   value: 1, label: "Version1"   },
            {   value: 2, label: "Version2"    },
            {   value: 2, label: "Version2"    }],
            
      }
      
      this.togglebutton = this.togglebutton.bind(this); 
      this.RetentionPaymentModal= this.RetentionPaymentModal.bind(this);
      this.RetentionDocumentsModal= this.RetentionDocumentsModal.bind(this);  
      this.UploadSuccessModal= this.UploadSuccessModal.bind(this); 
      this.OpenVersionModal= this.OpenVersionModal.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this)
      
    
    }
    action1() {
        this.setState({ action1: false });
    }

    RetentionPaymentModal() {
        this.setState({ RetentionPaymentModal: !this.state.RetentionPaymentModal });
        
        
            if(this.state.RetentionPaymentModal ==true){
                this.setState(
                {opacity:""}
                )
    
        }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )
                
                }
    }

    RetentionDocumentsModal() {
        this.setState({ RetentionDocumentsModal: !this.state.RetentionDocumentsModal });
        this.setState({ RetentionPaymentModal: !this.state.RetentionPaymentModal });
       
        
            if(this.state.RetentionDocumentsModal ==true && this.state.RetentionPaymentModal ==true){
                this.setState(
                {opacity:""}
                )
    
        }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )
                
                }
      }
      
      UploadSuccessModal() {
        this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });
        this.setState({ RetentionDocumentsModal: false });
       
        
            if(this.state.UploadSuccessModal ==true){
                this.setState(
                {opacity:""}
                )
    
        }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )
                
                }
      }
    //   OpenVersionModal= ()=> {
        OpenVersionModal(){
        this.setState({ OpenVersionModal: !this.state.OpenVersionModal });
       
       
        
            if(this.state.OpenVersionModal ==true){
                this.setState(
                {opacity:""}
                )
    
        }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )
                
                }
      }

    togglebutton=(Index)=> {  
        // const { open } = this.state;  
        // this.setState({  
        //     open: !open,  
        // }); 
        
        var multiCollapseIndex = this.state.multiCollapseIndex
    
        if(multiCollapseIndex!=Index || multiCollapseIndex==''){
          
          this.setState({multiCollapseIndex:Index})
      }
     
      
    } 
    handleChange = () => {
        console.log("hi");
        var selectAll = !this.state.selectAll;
        this.setState({ selectAll: selectAll });
        var checkedCopy = [];
        this.state.array.map(function(e, index) {
          checkedCopy.push(selectAll);
        });
        this.setState({
          checked: checkedCopy
        });
      };

      handleSingleCheckboxChange = index => {
        console.log(index);
    
        var checkedCopy = this.state.checked;
        checkedCopy[index] = !this.state.checked[index];
        if (checkedCopy[index] === false) {
          this.setState({ selectAll: false });
        }
    
        this.setState({
          checked: checkedCopy
        });
      };

      toggleVersionModal(e){
       
        this.setState({ OpenVersionModal: !this.state.OpenVersionModal });
        
      }

      toggleSuccessModal(e){
         
        this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });

        if(this.state.UploadSuccessModal ==true){
          this.setState(
          {opacity:""}
          )

  }
      else{
          this.setState(
             {opacity:"0.2"} 
          )
          
          }
        
      }

    render()
    {
        return(
            <div className="Container-fluid pageheight"  >
                {/* ---------Request Retention Payement Modal Start-------- */}

                <Modal isOpen={this.state.RetentionPaymentModal} >
            <div className={"modal-bg" + (this.state.RetentionPaymentModal === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header">
                    <div><h4 >Request Retention Payment</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.RetentionPaymentModal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                    <div >
                <ModalBody Style="modal-body modalbodys">
                   <div className="row text-left p-2">
                        <div className="col ">
                            <Form.Group controlId="formBasicCheckbox">
                                    <Form.Check type="checkbox" label="Request Payment against PBG" />
                            </Form.Group>
                            <Form.Group controlId="formBasicCheckbox">
                                    <Form.Check type="checkbox" label="Request Payment against warranty Expire" />
                            </Form.Group>
                            <Form.Group controlId="formBasicCheckbox">
                                    <Form.Check type="checkbox" label="Request Payment against Receipted LR/FAC/Completion of Job" />
                            </Form.Group>
                        </div> 
                  
                           
                            
                    </div>    
                   
                   
                </ModalBody>
                </div>
                <div>    
                <ModalFooter>
                <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.RetentionDocumentsModal} type="submit">Next</button>
                
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.RetentionPaymentModal} type="submit">Cancel</button>
                
                
                
                </div>

                    
                </ModalFooter>
                </div>
                </div>
                </Modal>

                {/* ---------Request Retention Payment Modal End-------- */}

                {/* ---------Upload Retention Document Modal on clicking Next Button START-------- */}

               
                <div>
                       <Modal isOpen={this.state.RetentionDocumentsModal} >
                         <div className={"modal-bg" + (this.state.RetentionDocumentsModal === 'false'  ? 'open' : '')}>
                    <div className="modalheads">
                       <ModalHeader HeaderStyle="modal-header">
                           <div className="modal-text"><h4 >Upload Retention Documents</h4></div>
                           
                           <button type="button" className="close" aria-label="Close" onClick={this.RetentionDocumentsModal} >
                               <span aria-hidden="true">&times;</span>
                           </button>
                           
                       </ModalHeader>
                    </div>
                    <div className="modalbodys">
                       <ModalBody Style="modal-body modalbodys">
                       
                         <div className="row pt-2">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-8">
                                        PO No. :
                                    </div>
                                    <div className="col">
                                      <b> Abc</b>
                                    </div>
                                </div>
                             </div>
                             <div className="col-md-6">
                                <div className="row">
                                    <div className="col">
                                     WBS No. :
                                    </div>
                                    <div className="col">
                                     <b> Abc</b>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="row pt-2">
                             
                              <div className="col-md-4">PO Line No. :</div> 
                              <div className="col"> <b> Abc</b></div>
                            
                            </div>
                            <div className="row pt-2">
                             
                              <div className="col-md-5">PI having PO No. and Current Date :</div> 
                               <div className="col-md-6"> 
                                    <div className="row">
                                    <div className="col-md-2 ml-2">  <FontAwesomeIcon className="align-middle" icon={"code-branch"}  color={"black"} title="Document Version" size="1x" onClick={this.OpenVersionModal} /></div>
                                    <div className="col">  <input type="file" className="form-control-file" id="exampleFormControlFile1"/></div>
                                    </div>
                                
                              </div>
                            
                            </div>
                            <div className="row pt-2">
                             
                              <div className="col-md-5 ">PBG :</div> 
                               <div className="col-md-6"> 
                                <div className="row">
                                  <div className="col-md-2 ml-2 ">  <FontAwesomeIcon className="align-middle" icon={"code-branch"}  color={"black"} title="Document Version" size="1x" onClick={this.OpenVersionModal} /></div>
                                  <div className="col">  <input type="file" className="form-control-file" id="exampleFormControlFile1"/></div>
                                </div>
                                
                              </div>
                            
                            </div>

                            <div className="row pt-2">
                             
                              <div className="col-md-5">PBG Confirmation :</div> 
                               <div className="col-md-6"> 
                                    <div className="row">
                                    <div className="col-md-2 ml-2">  <FontAwesomeIcon className="align-middle" icon={"code-branch"}  color={"black"} title="Document Version" size="1x" onClick={this.OpenVersionModal} /></div>
                                    <div className="col">  <input type="file" className="form-control-file" id="exampleFormControlFile1"/></div>
                                    </div>
                                
                              </div>
                            
                            </div>

                            <div className="row pt-2">
                             
                              <div className="col-md-5">Received LR/FAC Certificate/JOB Competion Certificate :</div> 
                               <div className="col-md-6"> 
                                    <div className="row">
                                    <div className="col-md-2 ml-2">  <FontAwesomeIcon className="align-middle" icon={"code-branch"}  color={"black"} title="Document Version" size="1x" onClick={this.OpenVersionModal} /></div>
                                    <div className="col">  <input type="file" className="form-control-file" id="exampleFormControlFile1"/></div>
                                    </div>
                                
                              </div>
                            
                            </div>
                            
                            
                           
                         
                      
                           
                        
                                  
                           {/* <div>
                              <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Upload</button>
                              <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.RetentionDocumentsModal} type="submit">Cancel</button>
                       
                           
                           </div> */}
                       
                       </ModalBody>
                    </div>
                    <div >    
                       <ModalFooter>
                               
                           <div>
                              <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.UploadSuccessModal} type="submit">Request Payment</button>
                              <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.RetentionDocumentsModal} type="submit">Back</button>
                       
                           
                           </div>
       
                           
                       </ModalFooter>
                    </div>
                       </div>
                       </Modal>
                       </div>
     

                {/* ---------Upload Retention Document Modal End-------- */}
                {/* -----upload successfull modal Start------ */}

                <SuccessFailureModal action={this.state.UploadSuccessModal} toggleSuccessModal={(e)=>this.toggleSuccessModal(e)} headertitle="Upload Successful" text="You have successfully uploaded documents." icon='check-circle' iconcolor="green" path='/RequestRetentionPayment' />

                {/* -----upload successfull modal End------ */}
                {/* -----version modal Start------ */}

                <VersionModal  action={this.state.OpenVersionModal}  toggleVersionModal={(e)=>this.toggleVersionModal(e)} headertitle="ABC"  icon='check-circle'  data={this.state.versiondata} />

                {/* -----version modal End------ */}
               <div className="Container-fluid p-4" style={{opacity:this.state.opacity}}>
                <div className="row pr-4" >
                    <div className="col-md-4 header ">
                        {this.state.supplierName}
                    </div>
                    <div className="col-md-4 ">
                    <Link  to ={{ pathname: '',state : {} }}> 
                        <button className="btn2 btn-sms1 mt-2 float-right" type="submit" onClick={this.RetentionPaymentModal}> Request Retention Payment </button>
                    </Link>
                    </div>
                    <div className="col pt-2  xs={last}">
                    <SearchBar placeholder="Search"  label="Search"  btnName=""  />
                    </div>
                </div>
                <div className="row-md-8 pr-4">
                    <div className="col ">
                        <div className="row  headerbar ">
                            <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar ">
                             <input 
                                type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll} />
                            </div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Item Number</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">Created On</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Amount</div>
                            {/* <div className="col pt-2 pb-2 borderheaderbar">Status</div> */}
                        </div>
                        {this.state.array.map((element,Index)=>
                        <div className={Index%2==0? 'row border ':'row  background '} 
                            onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                           <div className="col-md-1 pt-2 pb-2 borderheaderbar">
                            <input
                            type="checkbox" checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)}/>
                           </div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">1001</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar">ABC</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block">ABC</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text">ABC</div>
                           
                           {/* <div className="col pt-2 pb-2 borderheaderbar">ABC</div> */}
                             
                         <div  style={{maxWidth:"1400px"}} className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                         <form>
                                            <div></div>
                                            <div className="row">
                                                <div className="col-md-2">
                                                  <b>WBS Number:</b>
                                                </div>
                                                <div className="col">
                                                    XXX
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-2">
                                                  <b>Location:</b>
                                                </div>
                                                <div className="col">
                                                    XXX
                                                </div>
                                            </div> 
                                            
                                            <div className="row">
                                                <div className="col-md-2">
                                                 <b>Status:</b>
                                                </div>
                                                <div className="col">
                                                    XXX
                                                </div>
                                               
                                            </div>
                                             

                                              
                                              <div className="row d-block d-sm-none">
                                                <div className="col-md-2">
                                                    <b>Status:</b>
                                                </div>
                                                <div className="col">
                                                    1001
                                                </div>

                                              </div>
                                     

                                            
                                              
                                              
                                          </form>
                         </div>
                        </div>
                        )}           

                    </div>
                </div>
            </div>
            </div>
            
        )
    }
}